import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:

import Collapse from 'bootstrap/js/dist/collapse';
onFind('[data-bs-toggle="collapse"]',function (element) {
    new Collapse(element);
});

import * as translateFollowMouse from './scripts/translate-follow-mouse';
translateFollowMouse.init();

import * as imgTextSlider from './scripts/img-text-slider';
imgTextSlider.init();

import * as teaserScrollSlider from '@elements/scroll-slider';
teaserScrollSlider.init({
        arrows: false,
        dots: true,
        arrowIconClass: 'icon icon-arrow-right'
    },{
        base: '.js-scroll-slider-teaser',
        area: '.js-scroll-slider-teaser__area',
        item: '.js-scroll-slider-teaser__item',
        dotsContainer: '.js-scroll-slider-teaser__dots'
    }
);